import { AsyncPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { of } from 'rxjs';

import { FileManagerComponent } from '@shared/components/file-manager/file-manager.component';
import { File } from '@shared/components/file-manager/state/file.model';
import { IconComponent } from '@shared/components/icon/icon.component';
import { OverlayService } from '@shared/services/overlay.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NgClass, IconComponent],
  selector: 'aux-file-manager-uploaded-files',
  templateUrl: 'file-manager-uploaded-files.component.html',
})
export class FileManagerUploadedFilesComponent implements OnChanges, OnInit {
  private cdr = inject(ChangeDetectorRef);
  private overlayService = inject(OverlayService);

  uploadedFiles$ = of<File[]>([]);

  @Input() borderLess = true;
  classNames = '';
  @Input() disabled = false;
  @Input() fileManager?: FileManagerComponent;
  @Input() filesContainerClassNames = '';
  @Output() removeFile = new EventEmitter<File>();
  @Input() removeImmediately = true;
  @Input() titleLess = false;

  ngOnChanges(): void {
    this.classNames = `mt-4 text-sm overflow-auto ${this.filesContainerClassNames}`;
  }

  ngOnInit(): void {
    Promise.resolve()
      .then(() => {
        if (this.fileManager) {
          this.uploadedFiles$ = this.fileManager.fileQuery.selectAll();
          this.cdr.detectChanges();
        }
      })
      .catch(console.error);
  }

  onDownloadFile(file: File) {
    if (file) {
      if (!file.rawFile) {
        const fileSuccess = this.fileManager?.apiService.downloadFileFromPath(
          file.bucket_key,
          file.fileName
        );

        if (!fileSuccess) {
          this.overlayService.error('There was a problem downloading the file!');
        }
      } else {
        const newBlob = new Blob([file.rawFile]);

        this.fileManager?.apiService.downloadBlob(newBlob, file.fileName);
      }
    } else {
      this.overlayService.error('There was a problem downloading the file!');
    }
  }

  async onRemoveFile(file: File) {
    if (this.disabled) {
      return;
    }

    if (this.removeImmediately) {
      const success = await this.fileManager?.removeFile(file);

      if (success) {
        this.removeFile.emit(file);
        this.overlayService.success(`${file.fileName} removed!`);
      }
    } else {
      this.fileManager?.removeFileSoft(file);
      this.removeFile.emit(file);
    }
  }
}
